const SEARCH_TERM = '[Leitarorð'

export const isSearchTerm = (
  value: string,
  searchTerm = SEARCH_TERM,
): boolean => value.startsWith(searchTerm)
